import { BASE_ENDPOINT } from "../../../endpoint";

export const retrieveLoanPortfolioReportService = async (
	token: string,
	filters: { [key: string]: string },
	pagination?: {
		page: string;
		perPage: string;
	},
) => {
	const params = new URLSearchParams();
	Object.entries(filters || {}).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			params.append(key, value);
		}
	});
	if (pagination?.page) {
		params.append("page", pagination.page);
	}
	if (pagination?.perPage) {
		params.append("perPage", pagination.perPage);
	}
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/report/loanportfolio?${params.toString()}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			},
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
